module.exports = __webpack_public_path__ + "static/media/deleteIconInactive.8889dff1.svg";